import React from "react";
import contextProvider from "../../contextProvider";
import _ReactOBaseComponent, {
  withDefinedContext,
} from "../../_L0_components/_ReactOBaseComponent";
// import ReactOTooltip from "../../_L1_components/Elements/ReactOTooltip";
import Section from "../../_L1_components/Layout/Section";
import ReactOTabs from "../../_L1_components/Elements/ReactOTabs";

const context_exposed_methods = [];

class ProbeSetup extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      activeTab: "1",
      msgCopy: "Copy link",
      probe_cst_sync_status: {},
    };
    super(props, initState);

    this.apiStore = null;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  defineCallSet() {
    if (this.state.probe_capabilities) {
      this.setState({ probe_capabilities: undefined });
    }
    this.callsSet = this.apiStore.newCallsSet({
      state_setter: this._getStateSetter(),
      calls_set: {
        probe_cst_sync_status: {
          api_id: "probe_cst_sync_status",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        probe_capabilities: {
          api_id: "probe_capabilities",
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
        get_probe_setup: {
          api_id: "get_probe_setup",
          set_state: false,
          static_data: {
            probeuid: this.props.match.params.probeuid,
          },
        },
      },
    });
    this.callsSet.call(["probe_capabilities", "get_probe_setup"], {
      on_success: (status, datas) => {
        this.setState({
          probe_setup: datas.find((value) => {
            return value.call_id == "get_probe_setup";
          }),
        });
      },
    });
  }

  onComponentDidMount() {
    //	console.log("DEBUG :: ProbeSetup _ onComponentDidMount");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.defineCallSet();
  }

  componentDidUpdate(prev_props) {
    if (
      prev_props.match.params.probeuid !== undefined &&
      this.props.match.params.probeuid != prev_props.match.params.probeuid
    ) {
      this.setState({ probe_setup: null }, () => {
        this.defineCallSet();
      });
    }
  }

  onRender() {
    return (
      <Section designType="wide">
        <Section designType="wide" className="mb-4 border-bottom border-3 border-gray300">
          <div className="d-flex px-4 pt-4 pb-3">
            <div className="flex-grow-1 align-self-end">
              <div className="d-flex align-items-baseline">
                <h2>Device setup</h2>
                {/* <div
                  id="tp_copy_link"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => {
                    this.setState({ msgCopy: "Copy link" });
                  }}
                  onClick={() => {
                    this.getAppContext().copyURL();
                    this.setState({ msgCopy: "Copied" });
                  }}
                  onMouseLeave={() => {
                    setTimeout(() => {
                      this.setState({ msgCopy: "Copy link" });
                    }, 200);
                  }}
                  className="ml-3"
                >
                  <small className="icon-link" />
                </div>
                <ReactOTooltip
                  placement="right"
                  target="tp_copy_link"
                  text={this.state.msgCopy}
                /> */}
              </div>
            </div>
            {this.getAppContext().isCloud() ? (
              <small className="text-right text-muted align-self-end">
                <div>
                  {this.state.probe_cst_sync_status.probe_status == "not_deployed" &&
                  this.state.probe_cst_sync_status.sync_status == 1 ? (
                    <span className="text-muted">Probe not deployed</span>
                  ) : this.state.probe_cst_sync_status.probe_status == "maintenance" &&
                    this.state.probe_cst_sync_status.sync_status == 1 ? (
                    <span className="text-muted">Probe in maintenance</span>
                  ) : this.state.probe_cst_sync_status.probe_status == "deployed" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe <span className="text-danger">Offline</span>
                    </span>
                  ) : this.state.probe_cst_sync_status.probe_status == "not_deployed" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe not deployed <span className="text-danger">Offline</span>
                    </span>
                  ) : this.state.probe_cst_sync_status.probe_status == "maintenance" &&
                    this.state.probe_cst_sync_status.sync_status == 0 ? (
                    <span className="text-muted">
                      Probe in maintenance <span className="text-danger">Offline</span>
                    </span>
                  ) : null}
                </div>
                {this.state.probe_cst_sync_status.status ? (
                  <span>
                    <strong
                      className={
                        this.state.probe_cst_sync_status.status == "SYNCED"
                          ? "text-success"
                          : "text-orange"
                      }
                    >
                      {/*<span className={"mr-2 icon-" + (this.state.probe_cst_sync_status.status == 'SYNCED' ? 'cloud' : 'cloud-upload')}/>*/}
                      {this.state.probe_cst_sync_status.status == "SYNCED"
                        ? "Synchronized"
                        : "Waiting to push to probe"}
                    </strong>
                    <div>
                      (Last from{" "}
                      <strong>
                        {this.state.probe_cst_sync_status.last == "CLOUD"
                          ? "cloud"
                          : "probe"}
                      </strong>{" "}
                      at{" "}
                      {this.getAppContext()
                        .momentjs(this.state.probe_cst_sync_status.last_ts, "X")
                        .format("L LT")}
                      )
                    </div>
                  </span>
                ) : (
                  "-"
                )}
              </small>
            ) : null}
          </div>
        </Section>

        {this.state.probe_capabilities && this.state.probe_setup ? (
          <Section designType="wide" className="mx-4 mb-4">
            <ReactOTabs
              subroutesNavigator
              tabs={[
                {
                  title: "GENERAL SETTINGS",
                  to: {
                    pathname: "/" + this.props.match.params.probeuid + "/setup/general",
                    state: this.state.probe_setup,
                  },
                },
                {
                  title: "SIGNAL THRESHOLD",
                  to: "/" + this.props.match.params.probeuid + "/setup/signthold",
                },
                ...(this.state.probe_capabilities.ethernet === "yes"
                  ? [
                      {
                        title: "ETHERNET",
                        to: "/" + this.props.match.params.probeuid + "/setup/ethernet",
                      },
                    ]
                  : []),
                {
                  title: "USB",
                  to: "/" + this.props.match.params.probeuid + "/setup/usb",
                },
                ...(this.state.probe_capabilities.confap === "yes"
                  ? [
                      {
                        title: "HOTSPOT",
                        to: "/" + this.props.match.params.probeuid + "/setup/wifi",
                      },
                    ]
                  : []),
                {
                  title: "USERS",
                  to: "/" + this.props.match.params.probeuid + "/setup/users",
                },
                {
                  title: "SYNC",
                  to: "/" + this.props.match.params.probeuid + "/setup/sync",
                },
                // ...(this.getAppContext().isCloud()
                //   ? [
                //       {
                //         title: "NOTIFICATIONS",
                //         to:
                //           "/" + this.props.match.params.probeuid + "/setup/notifications",
                //       },
                //     ]
                //   : []),
                ...(this.getAppContext().isCloud() &&
                this.state.probe_setup?.data?.Cscheduler?.toLowerCase().includes("teams")
                  ? [
                      {
                        title: "TEAMS",
                        to: "/" + this.props.match.params.probeuid + "/setup/teams",
                      },
                    ]
                  : []),
                {
                  title: "ABOUT PROBE",
                  to: "/" + this.props.match.params.probeuid + "/setup/about",
                  align: "right",
                },
              ]}
            >
              {this.renderSubroute({
                probe_capabilities: this.state.probe_capabilities,
                cloudsyncServer: this.getAppContext().isCloud()
                  ? this.getAppContext().authHandler.getAccountData().cluster
                  : this.state.probe_capabilities.cloudsync[0].server,
                ...(this.getAppContext().isCloud()
                  ? {
                      onConfLoad: () => {
                        this.callsSet.call(["probe_cst_sync_status"]);
                      },
                    }
                  : {}),
              })}
            </ReactOTabs>
          </Section>
        ) : null}
      </Section>
    );
  }
}

export default contextProvider(
  withDefinedContext(ProbeSetup, "ProbeSetup", context_exposed_methods),
  {
    define: null,
  }
);
